import { render, staticRenderFns } from "./speechtext.vue?vue&type=template&id=7ec16b32&scoped=true"
import script from "./speechtext.vue?vue&type=script&lang=js"
export * from "./speechtext.vue?vue&type=script&lang=js"
import style0 from "./speechtext.vue?vue&type=style&index=0&id=7ec16b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec16b32",
  null
  
)

export default component.exports